import { Button, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '../../../types/store';
import GameCategoryListDisplay from '../../../components/gamecategory/game-category-list-display';
import AppConstants from '../../../constants/app-constants';
import AppActions from '../../../actions/app-actions';
import UIError from '../../../components/ui-error';

export default function CreateSpeakerGameForm() {
    const [language, setLanguage] = useState(1);
    const [categories, setCategories] = useState([4, 5]);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const create = useSelector((state:RootState) => state.page.create);
    const translate = useSelector((state:RootState) => state.ui.language);
    const settings = useSelector((state:RootState) => state.settings);
    
    useEffect(() => {
        dispatch(AppActions.CreateLobbyReset({}));
    }, []);
    
    useEffect(() => {
        if(create.success)
        {
            navigate("/speaker");
            dispatch(AppActions.CreateLobbyReset({}));
        }
    }, [create, navigate]);
    
    const onChangeLanguage = (value: number) => {
        setLanguage(value);
    };
    
    function onChangeCategory(id:number)
    {
        setCategories(prevCategories => {
            // Check if the id already exists in the array
            if (prevCategories.includes(id)) {
                // If it exists, remove it
                return prevCategories.filter(categoryId => categoryId !== id);
            } else {
                // If it doesn't exist, add it
                return [...prevCategories, id];
            }
        });
    }
    
    function onCreate() {
        dispatch(AppActions.CreateLobby({ mode: AppConstants.GAMEMODE_SPEAKER, categories: categories, language: language }));
    }
    
    return (
        <Stack gap={3} sx={{ width: "100%" }}>
            <FormControl fullWidth>
                <InputLabel>{translate.create.questionsLanguage}</InputLabel>
                <Select value={language.toString()} label={translate.create.questionsLanguage} defaultValue={"English"}
                        onChange={(event) => { onChangeLanguage(parseInt(event.target.value)) }} >
                    {settings.languages.map((v, i) => {
                        return <MenuItem key={i} value={v.id}>{v.language}</MenuItem>;
                    })}
                </Select>
            </FormControl>
            
            <GameCategoryListDisplay gameMode={AppConstants.GAMEMODE_SPEAKER} onChange={onChangeCategory} selectedCategories={categories} />
            
            <UIError message={create.error} />
            <Button variant="contained" disabled={create.isLoading} sx={{ marginBottom: 2 }} onClick={onCreate} >
                {translate.create.createLobby}
            </Button>
        </Stack>
    );
}
